/**
 * Abstract base class for all map commands
 */

import { IMapCommand, MapCommandType } from '../types';
import { generateId } from '../../../../utils/utils';

export abstract class BaseCommand implements IMapCommand {
  public readonly id: string;
  public readonly type: MapCommandType;
  public readonly timestamp: number;
  public readonly description: string;

  constructor(type: MapCommandType, description: string) {
    this.id = generateId();
    this.type = type;
    this.timestamp = Date.now();
    this.description = description;
  }

  abstract execute(): void;
  abstract undo(): void;

  canExecute(): boolean {
    return true;
  }

  canUndo(): boolean {
    return true;
  }

  toString(): string {
    return `${this.type}: ${this.description}`;
  }
}
